
































































































import { Component, Vue } from "vue-property-decorator";
import { State, Action } from "vuex-class";
import _ from "lodash";

// import {json2excel} from 'js2excel';
import GlobalMixins from "@/global.mixin.ts";
import appSnackbarService from "@/services/appSnackbar.service";

interface InventoryItem {
  inventoryId: number;
  description: string;
  startDt: Date|null;
  endDt: Date|null;
}

@Component({
  mixins: [GlobalMixins],
  components: {  }
})
export default class InventoryView extends Vue {

  @State("inventory") inventoryState: any;
  @Action("getInventory") getInventory: any;
  @Action("inventoryNew") inventoryNew: any;
  @Action("inventoryClose") inventoryClose: any;
  @Action("getInventoryAll") getInventoryAll: any;
  @Action("getInventoryItemCount") getInventoryItemCount: any;
  @Action("inventoryIsAnyOpen") inventoryIsAnyOpen: any;

  dialogInventoryClose = false;

  editingDialog = false;
  search = "";
  editedIndex = -1;
  isNewInventory = false;
  defaultItem: InventoryItem = {
    inventoryId: 0,
    description: "",
    startDt: null,
    endDt: null,
  };
  editedItem = Object.assign({}, this.defaultItem);

  rowsPerPageItems = [10, 25, 50, 100, 200, { text: "All", value: -1 }];

  pagination = {
    sortBy: "inventoryId",
    descending: true,
    page: 1,
    rowsPerPage: this.$cookies.isKey("inventory-rowsPerPage") ?
                        parseInt(this.$cookies.get("inventory-rowsPerPage"), 10) : 25
  };


  serversideSearch = _.debounce(() => {
    this.updatePagination(this.pagination);
  }, 300);

  created() {
    // this.updateData();
  }
  getHeaders() { return[
      { text: "#", value: "inventoryId", width: "1%", align: "left"},
      { text: this.$t("INVENTORY_TABLE_DESCRIPTION"), align: "left", sortable: true, value: "description", },
      { text: this.$t("INVENTORY_TABLE_START"), align: "left", sortable: true, value: "startDt",  },
      { text: this.$t("INVENTORY_TABLE_END"), align: "left", sortable: true, value: "endDt",  },
      { text: this.$t("INVENTORY_TABLE_FOUND"), align: "center", sortable: false, value: "itemCount",  },
      { text: this.$t("INVENTORY_TABLE_DETAILS"), align: "center", sortable: false, value: "details",  },
      { text: this.$t("TABLE_ACTIONS"), value: "actions", sortable: false },
    ];
  }
  reload() {
    this.updatePagination(this.pagination);
  }

  // lapozáskor hívódik meg, ill. ha item/oldalszámot választunk
  updatePagination(pagination) {

    this.$cookies.set("inventory-rowsPerPage", pagination.rowsPerPage);

    const searchexpression = this.search.trim();
    const x = searchexpression.split(" ");
    const page = {
      sortBy: pagination.sortBy,
      descending: pagination.descending,
      page: pagination.page,
      rowsPerPage: pagination.rowsPerPage,
      searchString: x,
    };
    this.getInventory(page)
    .then( () => {
      this.getInventoryItemCount()
      .then( () => {
        this.$forceUpdate();
      });
    });
  }

  closeInventory(item) {
    this.editedIndex = this.inventoryState.inventory.indexOf(item);
    this.editedItem = Object.assign({}, item);
    this.dialogInventoryClose = true;
  }

  inventoryCloseConfirm() {
    this.editedItem.endDt = new Date();

    this.inventoryClose({id: this.editedItem.inventoryId, data: this.editedItem, index: this.editedIndex})
    .then(() => {
      this.inventoryIsAnyOpen();
      this.closeInventoryClose();
    });

  }

  close() {
    this.editingDialog = false;
    this.$nextTick(() => {
      this.editedItem = Object.assign({}, this.defaultItem);
      this.editedIndex = -1;
    });
  }

  closeInventoryClose() {
    this.dialogInventoryClose = false;
    this.$nextTick(() => {
      this.editedItem = Object.assign({}, this.defaultItem);
      this.editedIndex = -1;
    });
  }

  save() {
    if (this.editedIndex === -1) {
      this.editedItem.startDt = new Date();
    }
    this.inventoryNew({data: this.editedItem, index: this.editedIndex})
    .then( () => {
      this.close();
      this.editedIndex = -1;
      this.inventoryIsAnyOpen();
    })
    .catch( err => {
      appSnackbarService.error(err);
    });
  }

  retrieveCount(item) {
    // TODO: start using it
    appSnackbarService.success("retrieveCount:", item.inventoryId);
  }

  inventoryDetails(item) {
    // console.log("inventoryDetails: ", item);

    this.$router.push({
      name: "INVENTORY_DETAILS_TITLE",
      params: { inventoryId: item.inventoryId },
    });
  }
}
